import { render } from "./FaqContent.vue?vue&type=template&id=df04e2d0"
import script from "./FaqContent.vue?vue&type=script&lang=js"
export * from "./FaqContent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__